import { render, staticRenderFns } from "./OrganisationAdd.vue?vue&type=template&id=51d8d835&scoped=true"
import script from "./OrganisationAdd.vue?vue&type=script&lang=js"
export * from "./OrganisationAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d8d835",
  null
  
)

export default component.exports